import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router";
import QuantityCalculationModal from "./QuantityCalculationModal";
import useQueryParams from "../../../../hooks/useQueryParams";

export default function QuantityCalculation({ asset }) {
  const params = useQueryParams();
  const navigate = useNavigate();
  const showFromUrl = params.get("showQuantityCalculation") === "true";
  const [open, setOpen] = useState(showFromUrl);

  const handleToggle = () => {
    if (open) {
      params.delete("showQuantityCalculation");
    } else {
      params.set("showQuantityCalculation", "true");
    }
    navigate({ search: params.toString() }, { replace: true });
    setOpen(v => !v);
  };

  return (
    <>
      <IconButton sx={{ ml: 1 }}>
        <InfoOutlinedIcon onClick={handleToggle} sx={{ fontSize: 28 }} />
      </IconButton>
      <QuantityCalculationModal open={open} asset={asset} onClose={handleToggle} />
    </>
  );
}
